export default {
  higher: 'Valor más alto',
  lower: 'Valor más bajo o cero',
  empty: 'Sin datos'
}
